import { TpvMsiPlan } from '@app/domain/models/tpv/msi.model';
import { MsiPlanDto } from '@app/data/dtos/tpv/msi.dto';

/** DTO de plan MSI -> entidad de dominio. */
export function mapMsiPlan(dto: MsiPlanDto): TpvMsiPlan {
  return {
    months: Number(dto.months ?? 0),
    minAmount: dto.min_amount !== undefined ? Number(dto.min_amount) : undefined,
    rate: dto.rate !== undefined ? Number(dto.rate) : undefined,
  };
}
